<!-- Logo for print-to-PDF -->
<div class="d-none d-print-block text-right">
  <img src="assets/img/legalandgeneral-dark.png" height="155">
</div>

<app-affordability-form
  [print]="true"
  [ngClass]="[affordabilityService.printResults ? 'd-none d-print-block' : 'd-none']"
  >
</app-affordability-form>
<div [ngClass]="[affordabilityService.printInputs ? 'd-print-block' : 'd-print-none']">
  <aside>
    <app-results-edit-search class='d-print-none'></app-results-edit-search>
  </aside>

  <aside>
    @if (loading) {
      <div class="normal-overlay">
        <div id="overlay">
          <div class="spinner"></div>
          <br />
          Loading...
        </div>
      </div>
    }
  </aside>

  @if (topMessage) {
    <div class="page-break container-section mt-4">
      <p [innerHTML]="topMessage"></p>
    </div>
  }

  @if (affordabilityService.result > 0) {
    <article class="result-area bg-primary container-section mt-md-5 mt-3">
      <div class="ty-4 results-wrapper py-4">
        <h2>Your results</h2>
        @if (!errored) {
          <div class="d-flex my-4 amounts-container">
            <div class="col-md-4 pl-0 amount-section me-5 pt-4">
              <div class="font-weight-light">{{ loanAmountText }}</div>
              <h2 class="result-amount mt-4">{{ affordabilityService.result | currency: 'GBP':'symbol':'1.0-0' }}</h2>
            </div>
            <div class="col-md-4 amount-section me-5 pl-0 pt-4">
              <div class="font-weight-light">Monthly Payment Amount</div>
              <h2 class="result-amount mt-4">{{ affordabilityService.monthlyAmount | currency: 'GBP':'symbol':'1.0-0' }}</h2>
            </div>
            @if (errored) {
              <span>Could not get result</span>
            }
          </div>
        }
      </div>
    </article>
  }

  @if (bottomMessage) {
    <div class="container-section my-md-5 my-3">
      <p [innerHTML]="bottomMessage"></p>
      <br />
      <br />
    </div>
  }
</div>

<!-- Company text footer for print-to-PDF -->
<footer class="mt-5 d-none d-print-block">
  <p>Legal &amp; General Home Finance Limited is a wholly owned subsidiary of Legal &amp; General Group plc. Registered in England and Wales number 04896447.</p>
  <p>Registered office: One Coleman Street, London EC2R 5AA. Legal &amp; General Home Finance Limited is authorised and regulated by the Financial Conduct Authority.</p>
</footer>
